




import Vue from 'vue';
import OfficialDocumentAdminList from '@/components/official-documents/official-document-admin-list.component.vue';

export default Vue.extend({
  components: {
    'official-document-admin-list': OfficialDocumentAdminList,
  },
});
